import { render, staticRenderFns } from "./DevMasterNew.vue?vue&type=template&id=23106688&scoped=true"
import script from "./DevMasterNew.vue?vue&type=script&lang=js"
export * from "./DevMasterNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23106688",
  null
  
)

export default component.exports